<p-dialog
  (visibleChange)="close()"
  [modal]="true"
  [showHeader]="false"
  [visible]="isOpened()"
  class="dialog-primary headless w380 authenticator-code-dialog"
>
  <div class="dialog-body">
    @if (!isConfirmed()) {
      <app-icon-alert-circle [height]="64" [width]="64"></app-icon-alert-circle>

      <div class="title text-18 fw-600">{{ 'users.authenticator.code.title' | translate }}</div>
      <div class="description text-14 fw-400">
        {{ 'users.authenticator.code.description' | translate }}
      </div>

      <form class="code-input-wrapper" (submit)="$event.preventDefault(); verify()">
        <input
          [class.ng-invalid]="isError()"
          [class.ng-touched]="isError()"
          pInputText
          class="code-input text-14 fw-400"
          [placeholder]="'users.authenticator.code.placeholder' | translate"
          [value]="code()"
          (input)="onCodeInput($event)"
        />

        @if (isError()) {
          <p class="error-message mt-8">
            {{ 'users.authenticator.code.error-message' | translate }}
          </p>
        }
      </form>
    } @else {
      <app-icon-success-circle [width]="64" [height]="64"> </app-icon-success-circle>

      <div class="title text-18 fw-600">{{ 'common.done' | translate }}</div>
      <div class="description text-14 fw-400">
        {{ 'users.authenticator.code.success-description' | translate }}
      </div>
    }
  </div>

  <ng-template pTemplate="footer">
    <div class="dialog-footer w100">
      @if (!isConfirmed()) {
        <p-button class="text-14 fw-600 h--40 w50" [severity]="'secondary'" (click)="cancel()">
          {{ 'button.cancel' | translate }}
        </p-button>

        @if (mode === 'setup') {
          <p-button
            class="text-14 fw-600 h--40 w50"
            [disabled]="!code() || isLoading()"
            [loading]="isLoading()"
            (click)="verify()"
          >
            {{ 'common.verify' | translate }}
          </p-button>
        } @else {
          <p-button
            class="text-14 fw-600 h--40 w50"
            [disabled]="!code() || isLoading()"
            [loading]="isLoading()"
            (click)="verify()"
          >
            {{ 'button.continue' | translate }}
          </p-button>
        }
      } @else {
        <p-button class="text-14 fw-600 h--40 w100" (click)="confirmSuccess()">
          {{ 'common.ok' | translate }}
        </p-button>
      }
    </div>
  </ng-template>
</p-dialog>
